var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-text",class:{ 'color-inherit': !!_vm.colorInherit },domProps:{"innerHTML":_vm._s(_vm.evaluatedText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }